module.exports = __webpack_public_path__ + "static/media/add_subject_discipline.040ff63b.svg";